module.exports = __webpack_public_path__ + "e1.no2.a7e45b85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/e1.no2.jpg
// module id = 18+r
// module chunks = 0